import moment from 'moment'
import bootbox from 'bootbox'
import * as bootstrap from 'bootstrap'
import * as _ from 'lodash'


var syncQueue: string[] = []

const meta = 'accounts'
window[`fnc_${meta}`] = initAccountsPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})


function initAccountsPage() {
    $('.iso-date').each(function() {
        const date = moment($(this).text()).local().fromNow() //format('lll')
        $(this).text(date.replace(/^./, date[0].toUpperCase()))
    }).removeClass('visually-hidden')

    $('.account-balance').each(function() {
        const acc = $(this).attr('data-account')

        const currency = globals.vars.userData.accountsById[acc]['currency']
        const value = parseFloat($(this).text())
        if (value >= 0)
            $(this).addClass('text-success')
        else
            $(this).addClass('text-danger')

        $(this).text( helpers.anonFigures( helpers.fmtCurrency(value, currency) ))
    }).removeClass('visually-hidden')

    const hasOnline = _.filter(globals.vars.userData.accounts, function(o) {
        return o['isOnline'] === true
    })

    if (hasOnline.length > 0)
        $('.sync-all-btn').removeClass('visually-hidden')


    $('.stats-sw').off().on('change', function(e) {
        e.preventDefault()
        const params = {
            accountId: $(this).attr('data-account'),
            params: JSON.stringify({ statistic: $(this).prop('checked') }),
            
        }
        helpers.updateAccount(params)
    })

    $('.summary-sw').off().on('change', function(e) {
        e.preventDefault()
        const params = {
            accountId: $(this).attr('data-account'),
            params: JSON.stringify({ summary: $(this).prop('checked') }),
            
        }
        helpers.updateAccount(params)
    })


    $('.sync-account').on('click', function(e) {
        e.preventDefault()        
        helpers.syncAccountTransactions($(this).attr('data-account'), true)
    })

    $('.sTitle').off().on('click', function(e) {
        e.preventDefault()

        helpers.appSettingsSet({'transactionsAccountId': $(this).attr('data-account')})

        if (!globals.vars.userData.accountsById[$(this).attr('data-account')]['favorite'])
            helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': false})

        window.location.href = '/transactions'
    })

    function processQueue() {
        if (syncQueue.length > 0) {
            const accountId = syncQueue.shift()

            if (DEBUG) console.log(`Processing ${accountId}`, 'Accounts to sync left', syncQueue)

            document.addEventListener(`sync-${accountId}`, function callback() {
                if (DEBUG) console.log((`Event received: sync-${accountId}`))

                document.removeEventListener(`sync-${accountId}`, callback)

                setTimeout(processQueue, 10)
            })

            helpers.syncAccountTransactions(accountId, false)
        } else {
            window.location.reload()
        }
    }

    $('.sync-all-btn').on('click', function(e) {
        e.preventDefault()

        syncQueue = _.map(_.filter(globals.vars.userData.accounts, function(o) {
            return o['isOnline'] === true && o['archived'] === false
        }), function(p) {
            return p['_id']
        })

        setTimeout(processQueue, 100)
    })

    $('.m_archive').off().on('click', function(e) {
        e.preventDefault()
        const params = {
            accountId: $(this).attr('data-account'),
            params: JSON.stringify({ archived: $(this).attr('data-state') }),
        }
        helpers.updateAccount(params, true)
    })

    $('.m_remove').off().on('click', function(e) {
        e.preventDefault()

        const accountId = $(this).attr('data-account')

        bootbox.confirm({
            message: global.i18n.t('accounts.delete_confirmation'),
            centerVertical: true,
            buttons: {
                confirm: {
                label:  global.i18n.t('accounts.yes'),
                className: 'btn-danger'
                },
                cancel: {
                    label: global.i18n.t('accounts.no'),
                    className: 'btn-light'
                }
            },
            callback: function (result) {
                if (!result)
                    return

                const params = {
                    accountId: accountId,
                }
 
                helpers.deleteAccount(params, true)

            }
        })
    })


    let data = []

    for (const [key, value] of Object.entries(globals.vars.currencies)) {
        data.push({
            id: key,
            text: `${key} - ${value}`
        })
    }

    $('.account-currency-select').select2({
        tags: false,
        dropdownParent: $("#edit-account-modal"),
        data: data
    })

    $('.account-type-select').select2({
        tags: true,
        dropdownParent: $("#edit-account-modal")
    })

    $('.favorite-star').off().on('click', function(e) {
        e.preventDefault()

        const account = globals.vars.userData.accountsById[($(this).attr('data-account'))]

        const params = {
            accountId: $(this).attr('data-account'),
            params: JSON.stringify({ favorite: !account['favorite'] }),
        }
        helpers.updateAccount(params, true)
    })

    $('.m_edit').off().on('click', function(e) {
        e.preventDefault()

        const lockEvent = new Event("bankSelectorLocked")
        document.querySelector("#bank-selector-modal").dispatchEvent(lockEvent)

        document.addEventListener('selectedInstitutionId', function callback(e) {
            const institution_id = e['detail']['selectedInstitutionId']

            document.removeEventListener('selectedInstitutionId', callback)

            $('#edit-account-modal').modal('show')
            // var myModal2 = new bootstrap.Modal(document.getElementById('edit-account-modal'), {})
            // myModal2.show()
            
            $('#inputInstitutionId').val(institution_id)
        })

        const account = globals.vars.userData.accountsById[$(this).attr('data-account')]

        const name =  account['custom_name'] !== '' ? account['custom_name'] : account['name'] !== '' ? account['name'] : ''
        const iban = account['iban'] !== '' ? account['iban'] !== null ? account['iban'] : '' : ''
        const currency = account['currency'] !== 'XXX' ? account['currency'] : 'EUR'
        const type = account['custom_cashAccountType'] !== '' ? account['custom_cashAccountType'] : ''
        const isPaymentAccount = account['payment_account']

        if (type !== '') {
            var newOption = new Option(type, '10', true, true)
            $('.account-type-select').append(newOption).trigger('change')
        } else {
            $('.account-type-select').val('0').trigger('change')
        }

        $('#inputInstitutionId').val(account['data']['info']['institution_id'])

        if (account['isOnline']) {
            $('#inputInstitutionId').closest('div.row').addClass('visually-hidden')
        } else {
            $('#inputInstitutionId').closest('div.row').removeClass('visually-hidden')
        }

        $('#swPayAccount').prop('checked', isPaymentAccount)

        $('#inputName').val(name)
        $('#inputSubtitle').val(iban)
        $('.account-currency-select').val(currency).trigger('change')
        $('#accountId').val(account['_id'])
    })


    $('#edit-account-form').on('submit', () => {
        const params = {
            accountId: $('#accountId').val(),
            params: JSON.stringify({
                'data.info.institution_id': $('#inputInstitutionId').val(),
                custom_name: $('#inputName').val(),
                iban: $('#inputSubtitle').val(),
                currency: $('.account-currency-select').val(),
                custom_cashAccountType: $('.account-type-select').select2('data')[0].text,
                payment_account: $('#swPayAccount').prop('checked')
            })
        }


        $('#edit-account-modal').modal('hide')

        helpers.updateAccount(params, true)

        return false
    })


    $('.export-lnk').off().on('click', function(e) {
        $(this).closest('.exportOpts').dropdown('toggle')


    })

}

